<template> 
  <div id="app" class="">
  <vue-snotify/>
<!-- <ModalIdle v-if="isIdle"></ModalIdle> -->

<div id="myModal" class="modal">
  <div class="modal-background"></div>
  <div class="modal-content" :style="return_modal_size('width: 25%','width: 85%')">
    <div  class="box">

<div class="columns is-multiline" style="padding:2em;">
<div class="columns is-12">La session a expiré.</div>

  <div class="column is-12 has-text-centered"> 
    <a @click="logout()" class="button is-fullwidth  has-background-grey-dark has-text-white has-tooltip-left has-tooltip-danger" data-tooltip="Déconnexion">
      &nbsp;&nbsp;<span class="icon"><i class="fas fa-sign-out-alt"></i></span>&nbsp;&nbsp;</a> 
  </div>
</div>

    </div>
  </div>
</div>



<!-- <div class="columns">
  <div class="column is-12 has-text-right  has-text-grey is-size-3">
    Is it Idle? - {{ isIdle }}
  </div>
</div> -->



<!-- <div v-if="!chkLoggedIn()" id="nB" class="navbar is-dark has-text-right">
<router-link to="/login" class="button is-pulled-right  is-light is-inverted"><span class="icon is-small"><i class="fas fa-sign-in-alt"></i></span> <span>Connexion&nbsp;&nbsp;</span>   </router-link>
</div> -->


<div v-if="chkLoggedIn()">

<div v-if="chkIfStudent()"> <!-- CHECK IF STUDENT ----  -->
  <div class="columns has-background-grey-dark has-text-light is-mobile" style="padding-bottom:1em;">
    <div class="column isCollege" :class="return_column_width('is-10','is-6')">&nbsp;&nbsp;{{return_college()}}</div> 
    <div class="column has-text-centered" :class="return_column_width('is-2','is-6')">
       <a @click="logout()" class="button is-pulled-right  has-background-grey-dark has-text-white has-tooltip-left has-tooltip-danger" data-tooltip="Déconnexion">&nbsp;&nbsp;<span class="icon"><i class="fas fa-sign-out-alt"></i></span>&nbsp;&nbsp;</a> 
       <a @click="show_password()" class="button is-pulled-right  has-background-grey-dark has-text-warning">&nbsp;&nbsp;<span class="icon"><i class="fas fa-lock"></i></span>&nbsp;&nbsp;</a> 
    </div>
  </div>
      <div v-if="showPass && check_mobile()" class="columns box is-mobile is-multiline is-gapless has-background-grey-lighter" style="margin-top:-1em;">
      <div class="column is-6 borderColumn">
        <!-- <input v-model="pass1" class="input is-fullwidth has-text-weight-bold" type="password" placeholder="Nouveau mot de passe"> -->
        <password class="has-text-weight-bold" v-model="pass1" :strength-meter-only="false" placeholder="Nouveau passe"/>
        </div>
      <div class="column is-6 borderColumn">
        <!-- <input v-model="pass2" class="input is-fullwidth has-text-weight-bold" type="password" placeholder="Re-taper le nouveau mot de passe"> -->
        <password class="has-text-weight-bold" v-model="pass2" :strength-meter-only="false" placeholder="Re-taper passe"/>
        </div>
      <div v-if="showPassError" class="column is-12 has-background-danger has-text-centered has-text-white is-size-7 has-text-weight-bold">&nbsp;&nbsp;Les mots ne correspondent pas &nbsp;&nbsp;</div>
      <div class="column borderColumn is-10"><a @click="save_password()" class="button is-fullwidth is-success"><span class="icon is-small"><i class="fas fa-save"></i></span><span></span></a></div>
      <div class="column borderColumn is-2 has-text-centered"><a @click="showPass=false" class="button is-fullwidth is-danger"><span class="icon is-small"><i class="fas fa-window-close"></i></span><span></span></a></div>
      </div>
      <!-- END MOBILE PASS-->
</div>  
<!-- END CHECK IF STUDENT ----  -->

<div v-if="chkAdmin() || chkProf()"> <!-- CHECK IF ADMIN/PROF ----  -->
<div v-if="check_mobile()">
<div class="columns is-vcentered has-background-grey-dark has-text-light is-mobile" style="">
  <div class="column isCollege is-4">&nbsp;&nbsp;{{return_college()}}</div>
  <div class="column has-text-centered is-4 is-size-7">{{return_user()}}&nbsp;</div>
  <div class="column is-4 has-text-right"> 
    <a @click="logout()" class="button is-small is-pulled-right  has-background-grey-dark has-text-white">&nbsp;&nbsp;<span class="icon"><i class="fas fa-sign-out-alt"></i></span>&nbsp;&nbsp;</a> 
    <a @click="show_password()" class="button is-small is-pulled-right  has-background-grey-dark has-text-warning">&nbsp;&nbsp;<span class="icon"><i class="fas fa-lock"></i></span>&nbsp;&nbsp;</a> 
  </div>
</div>

<div v-if="showPass" class="columns box is-mobile is-multiline is-gapless has-background-grey-lighter" style="margin-top:-1em;">
<div class="column is-6 borderColumn">
  <!-- <input v-model="pass1" class="input is-fullwidth has-text-weight-bold" type="password" placeholder="Nouveau mot de passe"> -->
  <password class="has-text-weight-bold" v-model="pass1" :strength-meter-only="false" placeholder="Nouveau passe"/>
  </div>
<div class="column is-6 borderColumn">
  <!-- <input v-model="pass2" class="input is-fullwidth has-text-weight-bold" type="password" placeholder="Re-taper le nouveau mot de passe"> -->
  <password class="has-text-weight-bold" v-model="pass2" :strength-meter-only="false" placeholder="Re-taper passe"/>
  </div>
<div v-if="showPassError" class="column is-12 has-background-danger has-text-centered has-text-white is-size-7 has-text-weight-bold">&nbsp;&nbsp;Les mots ne correspondent pas &nbsp;&nbsp;</div>
<div class="column borderColumn is-10"><a @click="save_password()" class="button is-fullwidth is-success"><span class="icon is-small"><i class="fas fa-save"></i></span><span></span></a></div>
<div class="column borderColumn is-2 has-text-centered"><a @click="showPass=false" class="button is-fullwidth is-danger"><span class="icon is-small"><i class="fas fa-window-close"></i></span><span></span></a></div>
</div>
<!-- END MOBILE PASS-->





<!-- MOBILE MENU  -->
<div class="columns is-vcentered has-background-grey-dark has-text-light is-mobile" style="margin-top:-2em;">
<div class="column is-4"><a v-if="chkAdmin()" @click="menu_student()" class="button is-small is-fullwidth is-pulled-right is-dark"><span class="icon is-small"> <i class="fas fa-user"></i> </span> <span>&nbsp;&nbsp;ÉLÈV&nbsp;&nbsp;</span>   </a></div>
<div class="column is-4"><a @click="menu_groups()"  class="button is-small is-fullwidth is-pulled-right  is-dark"><span class="icon is-small"> <i class="fas fa-users"></i> </span> <span>&nbsp;&nbsp;GRPS&nbsp;&nbsp;</span>    </a></div>
<div class="column is-4"><a @click="menu_schedule()"  class="button is-small is-fullwidth is-pulled-right  is-dark"><span class="icon is-small"> <i class="fas fa-calendar-alt"></i> </span> <span>&nbsp;&nbsp;SCHD&nbsp;&nbsp;</span>    </a> </div>
</div>
</div> <!-- END MOBILE ADMIN/PROF MENU  -->


<div v-else> <!-- "NORMAL" MENU  -->
<div class="columns is-gapless is-vcentered has-background-grey-dark has-text-light is-mobile" style="">


<div class="column is-6 has-background-grey-dark has-text-left" id="nav"> 

<a v-if="chkAdmin()" @click="menu_student()" style="color: aqua;" class="button is-large " :class="chk_menu_index(0)"><span class="icon is-small"> <i class="fas fa-user"></i> </span> <span>&nbsp;&nbsp;ÉLÈV&nbsp;&nbsp;</span>   </a>

<a @click="menu_groups()" style="color: aqua;" class="button is-large" :class="chk_menu_index(1)"><span class="icon is-small"> <i class="fas fa-users"></i> </span> <span>&nbsp;&nbsp;GRPS&nbsp;&nbsp;</span>    </a>

<a @click="menu_schedule()" style="color: aqua;"  class="button is-large  " :class="chk_menu_index(2)"><span class="icon is-small"> <i class="fas fa-calendar-alt"></i> </span> <span>&nbsp;&nbsp;SCHD&nbsp;&nbsp;</span>    </a> 

<!-- <a v-if="chkAdmin()" @click="menu_paiments()"  class="button is-large is-dark"><span class="icon is-small"> <i class="far fa-calendar-alt"></i> </span> <span>PAIE&nbsp;&nbsp;</span>    </a>  -->
<a v-if="chkAdmin()" @click="menu_paiments_II()" style="color: aqua;"  class="button is-large" :class="chk_menu_index(3)"><span class="icon is-small"> <i class="far fa-credit-card"></i> </span> <span>PAI&nbsp;&nbsp;</span>    </a> 
 
<a v-if="chkAdmin()" @click="menu_transmission()" style="color: aqua;"  class="button is-large" :class="chk_menu_index(4)"><span class="icon is-small"> <i class="fas fa-exchange-alt"></i> </span> <span>TRAN&nbsp;&nbsp;</span>   </a>



</div>   
  


<div class="column is-2 has-background-grey-dark has-text-light ">&nbsp;&nbsp;{{return_college()}}</div>
<!-- isCollege -->

<div class="column is-2 has-text-centered has-text-white is-size-7 has-text-weight-bold">{{return_user()}}</div>  
<div class="column is-2 has-text-right"> 
  <a @click="show_password()" class="button  has-background-grey-dark has-text-warning">&nbsp;&nbsp;<span class="icon"><i class="fas fa-lock"></i></span>&nbsp;&nbsp;</a> 
  <a v-if="chkAdmin()" @click="menu_admin()" class="button has-background-grey-dark has-text-link">&nbsp;&nbsp;<span class="icon"><i class="fas fa-cog"></i></span>&nbsp;&nbsp;</a> 
  <a @click="logout()" class="button  has-background-grey-dark has-text-white">&nbsp;&nbsp;<span class="icon"><i class="fas fa-sign-out-alt"></i></span>&nbsp;&nbsp;</a>
</div>
</div> 

</div> <!-- END "NORMAL" MENU  -->

</div>  
<!-- END CHECK IF ADMIN/PROF  ----  -->


<!-- CHANGE PASSWORD  -->
<div v-if="showPass">
<div v-if="!check_mobile()" class="columns is-mobile  is-gapless has-background-grey-dark" style="padding-top:1em;">
<div class="column is-5 has-text-centered has-text-weight-bold is-size-5"></div>
<div class="column is-2 borderColumn">
    <!-- <input v-model="pass1" class="input is-fullwidth has-text-weight-bold" type="password" placeholder="Nouveau mot de passe"> -->
    <password class="has-text-weight-bold" v-model="pass1" :strength-meter-only="false" placeholder="Nouveau mot de passe"/>
</div>
<div class="column is-2 borderColumn">
  <!-- <input v-model="pass2" class="input is-fullwidth has-text-weight-bold" type="password" placeholder="Re-taper le nouveau mot de passe"> -->
  <password class="has-text-weight-bold" v-model="pass2" :strength-meter-only="false" placeholder="Re-taper mot de passe"/>
</div>
<div class="column borderColumn is-2 has-text-centered">
  <a @click="save_password()" class="button is-fullwidth is-success"><span class="icon is-small"><i class="fas fa-save"></i></span><span></span></a>
  <span v-if="showPassError" class="has-background-danger has-text-white is-size-7 has-text-weight-bold">&nbsp;&nbsp;Les mots ne correspondent pas &nbsp;&nbsp;</span>
  </div>
<div class="column borderColumn is-1"><a @click="showPass=false" class="button is-fullwidth is-danger"><span class="icon is-small"><i class="fas fa-window-close"></i></span><span></span></a></div>
</div>
<!-- END DESKTOP -->


</div>
<!-- END SHOW STAFF ! -->



</div> <!-- END CHECK LOGGED IN!!!! -->



<div v-if="chkLoggedIn() && (chkAdmin() || chkProf())" class="columns is-vcentered is-gapless has-background-grey-dark" style="margin-bottom:0em;" >

</div>






<router-view/>


<!-- <div v-if="!chkLoggedIn()" class="columns is-gapless">
  <div class="column is-12 is-size-2">
    
<section class="hero is-medium is-primary is-bold">
  <div class="hero-body">
    <div class="container">
      <h1 class="title">
        myMEQ
      </h1>
      <h2 class="subtitle">
        The Choice For Smart Colleges
      </h2>
    </div>
  </div>
</section>

    <section class="hero is-dark">
      <div class="hero-body">
        <div class="container">

<div class="columns">

<div class="column is-2 has-text-centered">
<div class="columns  is-multiline">
<div class="column is-12 is-size-5">ONLINE</div>
<div class="column is-12"><span class="icon"><i class="fas fa-signal fa-lg"></i></span></div>
</div></div>

<div class="column is-2 has-text-centered">
<div class="columns  is-multiline">
<div class="column is-12 is-size-5">TRANSMISSIONS</div>
<div class="column is-12"><span class="icon"><i class="fas fa-share-alt-square fa-lg"></i></span></div>
</div></div>

<div class="column is-2 has-text-centered">
<div class="columns  is-multiline">
<div class="column is-12 is-size-5">SCHEDULES</div>
<div class="column is-12"><span class="icon"><i class="far fa-calendar-alt fa-lg"></i></span></div>
</div></div>

<div class="column is-2 has-text-centered">
<div class="columns  is-multiline">
<div class="column is-12 is-size-5">REPORTS</div>
<div class="column is-12"><span class="icon"><i class="fas fa-user-graduate fa-lg"></i></span></div>
</div></div>

<div class="column is-2 has-text-centered">
<div class="columns  is-multiline">
<div class="column is-12 is-size-5">TAX RECEIPTS</div>
<div class="column is-12"><span class="icon"><i class="fas fa-money-bill-alt fa-lg"></i></span></div>
</div></div>



</div>




        </div>
      </div>
    </section>

    <section class="hero is-primary">
      <div class="hero-body">
        <div class="container">
          <h1 class="title has-text-dark">
            Contact us for more iformation or to request a free trial
          </h1>
          <h2 class="subtitle has-text-dark has-text-weight-bold">
            <span class="icon"><i class="fas fa-envelope"></i></span>&nbsp;&nbsp;support@mymeq.ca
          </h2>
        </div>
      </div>
    </section>


  </div>
</div> -->


  </div>
</template>


<script>
import axios from 'axios';
import Password from 'vue-password-strength-meter'


export default {
  
	components: { Password  },


  data: function() {
    return {
      showNav: false,
      user: sessionStorage.getItem('user_ID'),
      showPass: false,
      showPassError: false,
      pass1:'',
      pass2:'' ,

// NEW VARIABLE
temp :0,

index_menu:1,

    }
  },

  created() {
    document.querySelector('#myModal').classList.remove('is-active');
  },

  computed: {
		isIdle() {return this.$store.state.idleVue.isIdle;}
	},

  watch: {

    isIdle: function() {
      if (this.$store.state.idleVue.isIdle) 
      {if (sessionStorage.getItem('isGood')) { document.querySelector('#myModal').classList.add('is-active');}}
    }


  },


  methods: {

check_mobile() {
// RETURN COLLEGE NAME - SHORT FOR MOBILE
if (sessionStorage.getItem('isMobile') == 'true')
  {return true}
  else {return false}
},
return_column_width(colD, colM) {
if (sessionStorage.getItem('isMobile') == 'true')
  {return colM} else {return colD} 
},
return_text_size(sizeD, sizeM) {
if (sessionStorage.getItem('isMobile') == 'true')
  {return sizeM} else {return sizeD} 
},
return_modal_size(sizeD, sizeM) {
if (sessionStorage.getItem('isMobile') == 'true')
  {return sizeM} else {return sizeD} 
},


return_college() {
// RETURN COLLEGE NAME - SHORT FOR MOBILE
if (sessionStorage.getItem('isMobile') == 'true')
  {return sessionStorage.getItem('college_nickname')}
  else {return sessionStorage.getItem('college')}
},

return_user() {
  return sessionStorage.getItem('user_name')
},

chk_menu_index:function(idx) {
  if (idx == this.index_menu) {return 'is-light has-text-dark'}
  {return 'is-dark'}
},

menu_student:function() {
    this.index_menu = 0
    this.$router.push({ 
            name: 'student', 
    });
},
menu_groups:function() {
  this.index_menu = 1
    this.$router.push({ 
            name: 'groups', 
    });
},
menu_schedule:function() {
  this.index_menu = 2
    this.$router.push({ 
            name: 'schedule', 
    });
},
menu_paiments:function() {
  this.index_menu = 3
    this.$router.push({ 
            name: 'paiements', 
    });
},
menu_paiments_II:function() {
  this.index_menu = 3
    this.$router.push({ 
            name: 'paiements_II', 
    });
},
menu_transmission:function() {
  this.index_menu = 4
    this.$router.push({ 
            name: 'transmission', 
    });
},
menu_bulletin:function() {
    this.$router.push({ 
            name: 'bulletin', 
    });
},

menu_admin:function() {
  this.index_menu = -1
    this.$router.push({ 
            name: 'admin', 
    });
},

show_password:function() {
 if (this.showPass) 
 {this.showPass = false; return;} 
 else {this.pass1=''; this.pass2=''; this.showPass = true;
      this.showPassError = false} 
},

save_password:function() {
  if (this.pass1.localeCompare(this.pass2) != 0)
  {this.showPassError = true}
  else {
  
  // CHECK IF STUDENT or STAFF
    var sql = ''
    if (this.chkIfStudent())  
    {sql = "UPDATE myMEQ_STUDENT SET student_webPass = '" + this.pass1.replace(/'/g,"''") + "' WHERE student_ID = " + sessionStorage.getItem('user_ID') }
    else { sql = "UPDATE MyMEQ_STAFF SET staff_PASSWORD = '" + this.pass1.replace(/'/g,"''") + "' WHERE staff_ID = " + sessionStorage.getItem('user_ID')  }
      axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
      .then(res => {

          this.$snotify.success('Saved !!', {
          timeout: 1000,
          showProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          position: "rightBottom",
          });

          this.showPassError = false ; this.showPass = false
      });

     } 
},



      logout:function() {

          sessionStorage.clear();
          document.querySelector('#myModal').classList.remove('is-active');

/*            sessionStorage.removeItem('user_ID')
              sessionStorage.removeItem('isGood')
              sessionStorage.removeItem('user_level')
              sessionStorage.removeItem('url_query')
              sessionStorage.removeItem('sql_prof') 
*/


              this.$router.push({ name: 'login' });  
      },

      chkLoggedIn:function(){
        if (sessionStorage.getItem('isGood') === null) {return false } else { return true  }
      },
      chkAdmin:function(){
        if (sessionStorage.getItem('user_level') === 'ADMIN') {return true } else { return false  }
      },
      chkProf:function(){
        if (sessionStorage.getItem('user_level') === 'PROF') {return true } else { return false  }
      },

      chkDemo:function(){
        if (sessionStorage.getItem('url_query') === '/query_general_DEMO') {return true } else { return false  }
      },


      chkIfStudent:function(){
        if (sessionStorage.getItem('user_level') === 'STUD') {return true } else { return false  }
      },
  }
}
</script>



<style>
@import url('https://fonts.googleapis.com/css?family=Work+Sans&display=swap');
#app {
  font-family: 'Work Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}






</style>
